import { ICargoType } from '../entities/cargoesData'
import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { scene } from '../main/scene-sidecar'
import { IBuildSelector } from '../tiles/buildSelectors'
import { buildSelectors } from '../tiles/buildSelectors-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'
import { IDialog } from '../uiParts/dialogs'
import { dialogs } from '../uiParts/dialogs-sidecar'
import { IStevieText } from '../uiParts/stevieText'
import { stevieText } from '../uiParts/stevieText-sidecar'

interface IData {
  isOpen: boolean
  isCreated: boolean
  dialog: dialogs.IDialog
  buildItems: IBuildSelector[]
  textName: IStevieText
  textDesc: IStevieText
  texts: IStevieText[]
}
let _data: IData | null = null
export const getData = () => {
  if (!_data) {
    let ctx = scene.getContext()

    let x = 20
    let y = 100

    let texts: IStevieText[] = []

    let dialog: IDialog = dialogs.create(20, 20, x, y, 'Debug', () => {
      setOpen(false)
    })

    let textName = stevieText.create(ctx.font24, x + 200, y + 50)
    stevieText.setText(textName, 'Name')
    texts.push(textName)
    let textDesc = stevieText.create(ctx.font16, x + 200, y + 75)
    stevieText.setText(textDesc, 'Description')
    texts.push(textDesc)

    _data = {
      isOpen: false,
      isCreated: false,
      dialog,
      buildItems: [],
      textName,
      textDesc,
      texts,
    }
    setOpen(false)
  }
  return _data
}

export const toggle = () => {
  setOpen(!getData().isOpen)
}

export const setDesc = (name: string, desc: string) => {
  let data = getData()
  stevieText.setText(data.textName, name)
  stevieText.setText(data.textDesc, desc)
}

export const setOpen = (isOpen: boolean) => {
  clickEater.update('uiDebug', isOpen)

  let data = getData()
  data.isOpen = isOpen
  dialogs.setVisible(data.dialog, isOpen)
  stevieText.setBulkVisible(data.texts, isOpen)

  let xs = data.dialog.x + 25
  let xm = xs + 100
  let x = xs
  let y = data.dialog.y + 50

  if (isOpen && !data.isCreated) {
    data.isCreated = true

    let cargoes: ICargoType[] = [
      'ice',
      'water',
      'steel',
      'food',
      'hydrogen',
      'battery',
      'power',
    ]

    let adv = () => {
      x += 50
      if (x > xm) {
        x = xs
        y += 50
      }
    }

    l.forEach(cargoes, (c) => {
      console.log(c)
      data.buildItems.push(buildSelectors.create(x, y, null, null, c))
      adv()
    })
  }

  l.forEach(data.buildItems, (c) => {
    buildSelectors.setVisible(c, isOpen)
  })
}

export const update = () => {
  // TODO: if active
  let s = common.getPhaserScene()
  let ctx = scene.getContext()
}
